import React, { Component } from 'react';

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state =  ({
        size: this.props.size || 0,
        spinner: this.props.spinner || 'fa-spinner',
        spin: this.props.spin || true,
        style: this.props.style || {},
        divStyle: this.props.divStyle || {}
    })
  }

    componentDidMount() {

    };

  _buildLoader (){
    let spinner = 'fa '+this.state.spinner;
    if (this.state.spin){
      spinner += ' fa-spin';
    }
    if (this.state.size > 0){
        spinner += ' fa-'+this.state.size+'x';
    }
    return spinner;
  }

  render() {
    let divStyle = this.state.divStyle;
      return (
      <div id="loader" style={divStyle} >
         <i className={this._buildLoader()} style={this.state.style} aria-hidden="true"></i>
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/lib/Loader.js